import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

export default function clientsCarouselInit() {
    const swiper = new Swiper('.swiper', {
        modules: [Navigation, Autoplay],
        loop: true,
        slidesPerView: 7,
        spaceBetween: 28,
        autoplay: {
            delay: 2000,
            disableOnInteraction: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 0
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            992: {
                slidesPerView: 7,
                spaceBetween: 28
            }
        }
    });
}
